module.exports = __webpack_public_path__ + "static/media/grid-full.1409d723.png";